import { render, staticRenderFns } from "./EditOrderPage.vue?vue&type=template&id=35d0a06d&scoped=true&"
import script from "./EditOrderPage.vue?vue&type=script&lang=js&"
export * from "./EditOrderPage.vue?vue&type=script&lang=js&"
import style0 from "./EditOrderPage.vue?vue&type=style&index=0&id=35d0a06d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d0a06d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35d0a06d')) {
      api.createRecord('35d0a06d', component.options)
    } else {
      api.reload('35d0a06d', component.options)
    }
    module.hot.accept("./EditOrderPage.vue?vue&type=template&id=35d0a06d&scoped=true&", function () {
      api.rerender('35d0a06d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Orders/EditOrderPage.vue"
export default component.exports